import React, { useCallback, useEffect, useState } from "react"
import {
  makeStyles,
  createStyles,
  Typography,
  Grid,
  Container,
  Button,
  TextField,
} from "@material-ui/core"
import { ReactComponent as MarkerIcon } from "./../../../assets/marker.svg"
import { ReactComponent as MapIcon } from "./../../../assets/map.svg"
import { ReactComponent as TreeIcon } from "./../../../assets/tree.svg"
import { ReactComponent as SweepingIcon } from "./../../../assets/sweeping.svg"
import { ReactComponent as JanitoralIcon } from "./../../../assets/janitoral-b.svg"
import { ReactComponent as CloudSnowIcon } from "./../../../assets/cloud-snow-b.svg"
import { ReactComponent as UpIcon } from "./../../../assets/up.svg"
import { ReactComponent as DownIcon } from "./../../../assets/down.svg"
import { ReactComponent as CloseIcon } from "./../../../assets/close-w.svg"
import { ReactComponent as PDFIcon } from "./../../../assets/pdf.svg"
import { ReactComponent as CheckIcon } from "./../../../assets/check-g.svg"
import { ReactComponent as LogInIcon } from "./../../../assets/log-in.svg"
import { decimalNumber, formatDateUTC, getUrlParam, isPastDate } from "../../../utils/Util"
import Box from "@mui/material/Box"
import Modal from "@mui/material/Modal"
import Divider from "@mui/material/Divider"
import { useNavigate } from "react-router-dom"
import Carousel from "react-material-ui-carousel"
import { useGraphQLService } from "../../../services/graphqlService"
import { useImageService } from "../../../services/imageService"
import { Loader } from "../../common/Loader"
import { useFetchImages } from "../../../utils/ImageHelper"

function BidDetailsMobile(props: any) {
  const classes = useStyles()
  const navigate = useNavigate()
  const imageService = useImageService()
  const imageHelper = useFetchImages()
  const [details, setDetails] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [hasOfferPending, setHasOfferPending] = useState(false)
  const [offers, setOffers] = useState<any[]>([])
  const [open, setOpen] = useState(false)
  const [openPDF, setOpenPDF] = useState(false)
  const [openImg, setOpenImg] = useState(false)
  const [openCounterModal, setOpenCounterModal] = useState(false)
  const [location, setLocation] = useState<any>({})
  const [groupData, setGroupData] = useState<any[]>([])
  const [bidId, setBidId] = useState("")
  const [isAccept, setIsAccept] = useState(true)
  const graphqlService = useGraphQLService()
  const [loadingImges, setLoadingImges] = useState(false)
  const [images, setImages] = useState<any[]>([])
  const [loadingPDF, setLoadingPDF] = useState(false)
  const [pdf, setPDF] = useState("")

  const getLocationData = useCallback(
    (id: any) => {
      setLoading(true)
      setLoadingImges(true)
      graphqlService
        .getLocation({ siteId: id })
        .then((response) => {
          setLocation(response)
          setLoading(false)
          getImageData(response)
        })
        .catch(() => {
          setLoading(false)
          setLoadingImges(false)
        })
    },
    [graphqlService]
  )

  const loadData = useCallback(
    (sfid: any, signal?: AbortSignal) => {
      setLoading(true)
      setLoadingPDF(true)
      graphqlService
        .getBidDetails({ sfid: sfid }, signal)
        .then((response) => {
          let temporalOffers: any[] = []
          let details = response?.details
          details = details.sort((a: any, b: any) => {
            if (a.sort_order > b.sort_order) {
              return 1
            }
            if (a.sort_order < b.sort_order) {
              return -1
            }
            return 0
          })

          details.map((d: any) => {
            temporalOffers.push({
              sfid: d.sfid,
              newAmount: d.counter_offer_price
                ? Number(d.counter_offer_price)
                : d.counter_offer_price,
              counter: d.counter_offer_price
                ? Number(d.counter_offer_price)
                : d.counter_offer_price,
              caseOffer: Number(d.case_snow_offer),
              openField: false,
              active: !!d.counter_offer_price,
            })
          })
          setOffers(temporalOffers)
          setLoading(false)
          getLocationData(response?.site_id)
          groupDetails(response)
          getPDF(response)
        })
        .catch(() => {
          setLoading(false)
          setLoadingPDF(false)
        })
    },
    [getLocationData, graphqlService]
  )

  const getPDF = (response: any) => {
    let sfid = ""
    response?.exhibits?.map((e: any) => {
      if (e.title.indexOf("Exhibit B") >= 0) {
        sfid = e.sfid
      }
    })

    imageService
      .getPDF({ sfid })
      .then((response) => {
        setPDF(response)
        setLoadingPDF(false)
      })
      .catch(() => {
        console.log("error PDF")
      })
  }

  const getImageData = useCallback(async (response: any) => {
    let totalImg = response?.attachments?.length
    if (!totalImg || !response?.sfid) {
      setLoadingImges(false)
      setImages([])
      return
    }
    const sfids = response?.attachments.map((a: any) => a.sfid)
    const imagesData = await imageHelper.getImages(sfids, response?.sfid)
    setImages(imagesData)
    setLoadingImges(false)
  }, [])

  useEffect(() => {
    const controller = new AbortController()
    const id = getUrlParam("id") as string
    if (id) {
      setBidId(id)
      loadData(id, controller.signal)
    } else {
      navigate("/bids")
    }

    return () => controller.abort()
  }, [loadData, navigate])

  const handleDecline = useCallback(() => {
    setLoading(true)
    graphqlService
      .rejectBid({ sfid: bidId })
      .then(() => {
        loadData(bidId)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [bidId, graphqlService, loadData])

  const handlePDF = (isAccept: boolean) => {
    setIsAccept(isAccept)
    if (getExhibitB() === "") {
      if (isAccept) {
        acceptExhibit()
      } else {
        handleCounter()
      }
    } else {
      setOpen(true)
    }
  }

  const handleAcceptPDF = () => {
    if (isAccept) {
      acceptExhibit()
    } else {
      handleCounter()
    }
  }

  const handleCounter = useCallback(() => {
    setOpen(false)
    let coutners: any[] = []

    for (let group of details?.groupedDetails) {
      for (let d of group.details) {
        let offer = offers.find((o) => o.sfid === d.sfid)
        if (offer.newAmount > offer.caseOffer) {
          coutners.push({
            counter_id: offer.sfid,
            counter_amount: offer.newAmount,
          })
        } else {
          coutners.push({
            counter_id: offer.sfid,
            counter_amount: offer.caseOffer,
          })
        }
      }
    }

    setLoading(true)
    graphqlService
      .makeCounterBid({ sfid: bidId, counters: coutners })
      .then(() => {
        loadData(bidId)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [bidId, details?.groupedDetails, graphqlService, loadData, offers])

  const inputChanged = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
    var removedText = e.target.value.replace(/\D+/g, "")
    setOffers((values) =>
      values.map((v, i) =>
        index === i
          ? {
              ...v,
              newAmount: Number(removedText),
            }
          : v
      )
    )
  }

  const openField = (index: any) => {
    setGroupData((group) =>
      group.map((g, j) =>
        index === j
          ? {
              ...g,
              open: true,
            }
          : g
      )
    )
  }

  const acceptExhibit = useCallback(() => {
    setOpen(false)
    setLoading(true)
    graphqlService
      .acceptBid({ sfid: bidId })
      .then(() => {
        loadData(bidId)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [bidId, graphqlService, loadData])

  const groupDetails = (data: any) => {
    if (
      data.bid_status == "No Response" &&
      isPastDate(data.contract_end_date)
    ) {
      data.bid_status = "Expired"
    }

    let scopes: any[] = []
    for (let d of data.details) {
      if (scopes.findIndex((s) => s === d.bid_details_title) === -1) {
        scopes.push(d.bid_details_title)
      }
    }

    let groupedDetails: any[] = []
    for (let s of scopes) {
      let scopeDetails: any[] = []
      for (let d of data.details) {
        if (d.bid_details_title === s) {
          scopeDetails.push(d)
        }
      }
      groupedDetails.push({ name: s, details: scopeDetails, open: false })
    }

    data.groupedDetails = groupedDetails.sort()
    setGroupData(groupedDetails.sort())
    setDetails(data)
  }

  const checkIncrement = (details: any) => {
    let check = false
    details.map((d: any) => {
      if (d.increment) {
        check = true
      }
    })
    return check
  }

  const getOfferIndex = (detail: any) => {
    let offer = offers.find((o: any) => o.sfid === detail.sfid)

    return offers.findIndex((o) => o === offer)
  }

  const isOpen = (detail: any) => {
    let offer = offers.find((o: any) => o.sfid === detail.sfid)

    return offer.openField
  }

  const toogleInput = (detail: any) => {
    setOffers((values) =>
      values.map((v, j) =>
        detail.sfid === v.sfid
          ? {
              ...v,
              openField: !v.openField,
              newAmount: null,
            }
          : v
      )
    )
  }

  const isCounter = (group: any) => {
    let isCounter = false

    for (let d of group.details) {
      let offer = offers.find((o) => o.sfid === d.sfid)
      if (offer.caseOffer < offer.newAmount) {
        isCounter = true
      }
    }

    return isCounter
  }

  const noResponseHasCounter = () => {
    let isCounterUpdate = false
    for (let group of details?.groupedDetails) {
      for (let d of group.details) {
        let offer = offers.find((o) => o.sfid === d.sfid)
        if (offer.caseOffer < offer.counter) {
          isCounterUpdate = true
        }
      }
    }

    return isCounterUpdate && details.bid_status === "No Response"
  }

  const isCounterDetail = (detail: any) => {
    let offer = offers.find((o) => o.sfid === detail.sfid)

    return offer.caseOffer < offer.newAmount
  }

  const getExhibitB = () => {
    let id = ""
    details?.exhibits?.map((e: any) => {
      if (e.title.indexOf("Exhibit B") >= 0) {
        id = e.sfid
      }
    })
    return id
  }

  const checkPending = () => {
    let isCounterUpdate = false
    offers.map((o) => {
      if (o.caseOffer < o.newAmount) {
        isCounterUpdate = true
      }
    })

    return isCounterUpdate
  }

  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={() => setOpen(false)}
      >
        <Box className={classes.style}>
          <div className={classes.iframeBlock}>
            {loadingPDF ? (
              <Loader />
            ) : (
              <iframe className="w-full h-full" src={pdf} />
            )}
          </div>
          <div className="flex flex-col items-center">
            <Button
              onClick={() => handleAcceptPDF()}
              style={{
                borderRadius: "100px",
                backgroundColor: "#0F2150",
                color: "#fff",
                marginTop: "80px",
                margin: "auto",
                marginBottom: "10px",
              }}
              className="w-40"
            >
              I Accept
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openCounterModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={() => setOpenCounterModal(false)}
      >
        <Box className={classes.counterModalStyle}>
          <div className={classes.counterModalMessage}>
            <p className="font-bold text-lg mb-4">Counter Offer Submission</p>
            <p>
              By clicking I Accept, you are agreeing to all current Case Offers
              which have not been countered, in addition to the ones which have
              been countered.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <Button
              onClick={() => handlePDF(false)}
              style={{
                marginTop: "80px",
                margin: "auto",
                marginBottom: "10px",
              }}
              className={classes.actionButton + " w-40"}
            >
              I Accept
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openPDF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={() => setOpenPDF(false)}
      >
        <Box className={classes.style}>
          <div className={classes.iframeBlock}>
            {loadingPDF ? (
              <Loader />
            ) : (
              <iframe className="w-full h-full" src={pdf} />
            )}
          </div>
        </Box>
      </Modal>
      {openImg && (
        <Modal
          open={openImg}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          onClose={() => setOpenImg(false)}
        >
          <Box className={classes.styleImg}>
            <div className={classes.iframeBlockImg}>
              <div className="p-8">
                {!!images?.length && (
                  <Carousel
                    animation={"slide"}
                    autoPlay={false}
                    navButtonsAlwaysVisible={true}
                  >
                    {images.map((img: any, i: any) => (
                      <div key={i} className="flex flex-col items-center">
                        {loadingImges ? (
                          <Loader />
                        ) : (
                          <img
                            className={classes.carouselImg}
                            alt="photo"
                            src={img}
                          />
                        )}
                      </div>
                    ))}
                  </Carousel>
                )}
                {!images?.length && <div>The site has no maps to display</div>}
              </div>

              <Button
                variant="text"
                onClick={() => setOpenImg(false)}
                className={classes.imgButtonClose}
              >
                <CloseIcon />
              </Button>
            </div>
          </Box>
        </Modal>
      )}

      <div className="h-fit pb-1 bg-gradient-to-b from-case-grad-mid to-case-grad-to-mobile">
        <div>
          <Container className={classes.container}>
            <Grid container>
              <Grid item xs={9}>
                <div className={classes.secondaryTitleMobile}>
                  <Typography noWrap className={classes.titleFontMobile}>
                    {details?.customer_name}
                  </Typography>
                </div>
                <Typography className={classes.secondaryTitleFont}>
                  <div className="flex flex-row items-center">
                    <span>
                      <MarkerIcon className="w-4 mr-1.5" />
                    </span>
                    <span className={classes.locationName}>
                      {details.bid_location_name}
                    </span>
                  </div>
                </Typography>
              </Grid>
              <Grid item xs={3} className={classes.mapButton}>
                <Button
                  variant="text"
                  onClick={() => setOpenImg(true)}
                  className={classes.imgButton}
                >
                  <span className="flex flex-col items-center">
                    <MapIcon />
                    <span>Site Map</span>
                  </span>
                </Button>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>

      <div>
        <Container className={classes.container + " bg-gray-bid-dates"}>
          <Grid container>
            <Grid item xs={6} className="flex flex-col items-center">
              <div className="flex flex-col items-center">
                <span className={classes.infoFont}>
                  {details?.contract_start_date
                    ? formatDateUTC(details?.contract_start_date)
                    : "-"}
                </span>
                <Typography noWrap className={classes.infoTitle}>
                  Start Date
                </Typography>
              </div>
            </Grid>
            <Grid item xs={6} className="flex flex-col items-center">
              <div className="flex flex-col items-center">
                <span className={classes.infoFont}>
                  {formatDateUTC(details?.contract_end_date)}
                </span>
                <Typography noWrap className={classes.infoTitle}>
                  End Date
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div className={classes.contain}>
        <Container className={classes.container}>
          <Grid container>
            <Grid
              item
              xs={12}
              className={classes.statusPill + " flex flex-col items-center"}
            >
              <Typography
                className={
                  details.bid_status === "Awarded"
                    ? classes.blueStatus
                    : details.bid_status === "Accepted"
                    ? classes.greenStatus
                    : details.bid_status === "Declined" ||
                      details.bid_status === "Not Awarded" ||
                      details.bid_status === "Terminated"
                    ? classes.redStatus
                    : details.bid_status === "No Response"
                    ? classes.newBidStatus
                    : details.bid_status === "Expired"
                    ? classes.expiredStatus
                    : classes.yellowStatus
                }
              >
                <span>
                  {details.bid_status === "No Response"
                    ? "Open Bid"
                    : details.bid_status}
                </span>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Divider variant="middle" className={classes.divider} />
            </Grid>

            <Grid item xs={12}>
              <Typography noWrap className={classes.title}>
                Bid Details
              </Typography>
            </Grid>

            {groupData &&
              !!groupData.length &&
              groupData.map((g: any, index: any) => (
                <Grid key={index} item xs={12}>
                  <div className={classes.grid}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        className={
                          classes.cardIndicator +
                          " " +
                          (details.service_line === "Snow"
                            ? classes.snow
                            : details.service_line === "Land"
                            ? classes.landscape
                            : details.service_line === "Janitorial"
                            ? classes.janitorial
                            : classes.sweeping)
                        }
                      >
                        <Grid container>
                          <Grid item xs={2}>
                            <div className={classes.iconServiceLine}>
                              <span className="font-bold">
                                {details.service_line === "Snow" ? (
                                  <CloudSnowIcon />
                                ) : details.service_line === "Land" ? (
                                  <TreeIcon />
                                ) : details.service_line === "Janitorial" ? (
                                  <JanitoralIcon />
                                ) : (
                                  <SweepingIcon />
                                )}
                              </span>
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={
                              isCounter(g) &&
                              details.bid_status !== "No Response"
                                ? 6
                                : 10
                            }
                          >
                            <Typography
                              className={
                                classes.cardTitleDetail +
                                " " +
                                (details.service_line === "Snow"
                                  ? classes.snowText
                                  : details.service_line === "Land"
                                  ? classes.landscapeText
                                  : details.service_line === "Sweeping"
                                  ? classes.sweepingText
                                  : classes.janitorialText)
                              }
                            >
                              {g.name}
                            </Typography>
                          </Grid>

                          {isCounter(g) &&
                            details.bid_status !== "No Response" && (
                              <Grid item xs={4}>
                                <div className={classes.counterDiv}>
                                  <Typography noWrap>
                                    <span className={classes.coutnerStatus}>
                                      Counter
                                    </span>
                                  </Typography>
                                </div>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>

                      {g?.details[0].frequency && (
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid
                              item
                              xs={6}
                              className="flex flex-col items-center"
                            >
                              <div className={classes.cardDetailName}>
                                FREQUENCY
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              className="flex flex-col items-center"
                            >
                              <div className={classes.cardDetailDescription}>
                                {g?.details[0].frequency}
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <Divider variant="middle" className={classes.divider} />
                      </Grid>

                      {details.bid_status === "No Response" &&
                        !noResponseHasCounter() && (
                          <>
                            <Grid item xs={12}>
                              <Grid container>
                                {checkIncrement(g?.details) && (
                                  <Grid item xs={6}>
                                    <div className="w-full text-left float-left ">
                                      <div
                                        className={
                                          "min-w-40 ml-4 mr-4 mb-0 mt-4 rounded flex flex-col items-center"
                                        }
                                      >
                                        <span
                                          className={classes.cardDetailName}
                                        >
                                          INCREMENT
                                        </span>
                                      </div>
                                    </div>
                                  </Grid>
                                )}
                                <Grid
                                  item
                                  xs={checkIncrement(g?.details) ? 6 : 12}
                                >
                                  <div className="w-full text-left float-left ">
                                    <div
                                      className={
                                        (details.service_line === "Snow"
                                          ? classes.snow
                                          : details.service_line === "Land"
                                          ? classes.landscape
                                          : details.service_line ===
                                            "Janitorial"
                                          ? classes.janitorial
                                          : classes.sweeping) +
                                        " min-w-40 ml-6 mr-6 mb-0 mt-4 rounded-t flex flex-col items-center "
                                      }
                                    >
                                      <span
                                        className={
                                          "font-bold" +
                                          " " +
                                          (details.service_line === "Snow"
                                            ? classes.snowText
                                            : details.service_line === "Land"
                                            ? classes.landscapeText
                                            : details.service_line ===
                                              "Sweeping"
                                            ? classes.sweepingText
                                            : classes.janitorialText)
                                        }
                                      >
                                        CASE OFFER
                                      </span>
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>

                            {g?.details &&
                              g.details.map((detail: any, index: any) => (
                                <React.Fragment key={index}>
                                  <Grid item xs={12}>
                                    <Grid container>
                                      {detail.increment && (
                                        <Grid item xs={6}>
                                          <div className="w-full text-left float-left ">
                                            <div
                                              className={
                                                "min-w-40 ml-4 mr-4 mb-0 mt-0 rounded flex flex-col items-center"
                                              }
                                            >
                                              <span className="mb-1.5 mt-1.5">
                                                {detail.increment}
                                              </span>
                                            </div>
                                          </div>
                                        </Grid>
                                      )}
                                      <Grid
                                        item
                                        xs={checkIncrement(g?.details) ? 6 : 12}
                                      >
                                        <div className="w-full text-left float-left ">
                                          {g.open && g?.details.length !== 1 && (
                                            <div className={classes.toogleIcon}>
                                              <span
                                                onClick={() =>
                                                  toogleInput(detail)
                                                }
                                              >
                                                {isOpen(detail) ? (
                                                  <UpIcon />
                                                ) : (
                                                  <DownIcon />
                                                )}
                                              </span>
                                            </div>
                                          )}
                                          <div
                                            className={
                                              (details.service_line === "Snow"
                                                ? classes.snow
                                                : details.service_line ===
                                                  "Land"
                                                ? classes.landscape
                                                : details.service_line ===
                                                  "Janitorial"
                                                ? classes.janitorial
                                                : classes.sweeping) +
                                              " min-w-40 ml-6 mr-6 mb-0 mt-0 flex flex-col items-center "
                                            }
                                          >
                                            <span
                                              className={
                                                "text-2xl font-bold  mb-3.5 flex flex-row items-center" +
                                                " " +
                                                (details.service_line === "Snow"
                                                  ? classes.snowText
                                                  : details.service_line ===
                                                    "Land"
                                                  ? classes.landscapeText
                                                  : details.service_line ===
                                                    "Sweeping"
                                                  ? classes.sweepingText
                                                  : classes.janitorialText)
                                              }
                                            >
                                              ${decimalNumber(detail.case_snow_offer)}
                                            </span>
                                          </div>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    className={
                                      isCounterDetail(detail)
                                        ? classes.cardInputCoutner
                                        : classes.cardInput
                                    }
                                  >
                                    <Grid container>
                                      <Grid item xs={12}>
                                        {(isOpen(detail) ||
                                          (g.open &&
                                            g?.details.length === 1)) && (
                                          <div className="w-full flex flex-row items-center">
                                            <div className="w-full flex flex-col items-center">
                                              <p>Make an Offer</p>
                                            </div>
                                            <div className="w-full flex flex-col items-center">
                                              <TextField
                                                id={"outlined-helperText"}
                                                variant={"outlined"}
                                                size="small"
                                                disabled={
                                                  !(
                                                    details.bid_status ===
                                                    "No Response"
                                                  )
                                                }
                                                onChange={(
                                                  e: React.ChangeEvent<HTMLInputElement>
                                                ) =>
                                                  inputChanged(
                                                    e,
                                                    getOfferIndex(detail)
                                                  )
                                                }
                                                value={
                                                  offers[getOfferIndex(detail)]
                                                    .newAmount
                                                }
                                                type="number"
                                                style={{
                                                  backgroundColor: "#FFF",
                                                  border: "none",
                                                  borderRadius: "5px",
                                                }}
                                                className={classes.counterInput}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              ))}
                          </>
                        )}

                      {(details.bid_status !== "No Response" ||
                        noResponseHasCounter()) && (
                        <>
                          <Grid item xs={12}>
                            {g?.details &&
                              g.details.map((detail: any, index: any) => (
                                <React.Fragment key={index}>
                                  <Grid container>
                                    <Grid item xs={12}>
                                      {detail.increment && (
                                        <div className="w-full flex flex-row items-center mt-4">
                                          <div className="w-full flex flex-col items-center">
                                            <span
                                              className={
                                                classes.cardIncrementCounter
                                              }
                                            >
                                              INCREMENT
                                            </span>
                                          </div>
                                          <div className="w-full">
                                            <span className="ml-3 mb-1.5 mt-1.5">
                                              {detail.increment}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </Grid>

                                    <Grid item xs={12}>
                                      <Grid container>
                                        <Grid item xs={6}>
                                          <div className="w-full text-left float-left ">
                                            <div
                                              className={
                                                " min-w-40 ml-4 mr-4 mb-0 mt-2 flex flex-row items-center w-full"
                                              }
                                            >
                                              <div className="w=1/3">
                                                <div className="flex flex-col items-center mt-3">
                                                  {isCounterDetail(detail) ? (
                                                    <LogInIcon />
                                                  ) : (
                                                    <CheckIcon />
                                                  )}
                                                </div>
                                              </div>
                                              <div
                                                className={
                                                  "flex flex-col items-center w-2/3"
                                                }
                                              >
                                                <span className="">
                                                  {isCounterDetail(detail)
                                                    ? "COUNTER"
                                                    : "ACCEPTED"}
                                                </span>
                                                <span className="text-xl font-bold mb-3.5 flex flex-row items-center">
                                                  $
                                                  {isCounterDetail(detail)
                                                    ? decimalNumber(detail.counter_offer_price)
                                                    : decimalNumber(detail.case_snow_offer)}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <div className="w-full text-left float-left ">
                                            <div
                                              className={
                                                (details.service_line === "Snow"
                                                  ? classes.snow
                                                  : details.service_line ===
                                                    "Land"
                                                  ? classes.landscape
                                                  : details.service_line ===
                                                    "Janitorial"
                                                  ? classes.janitorial
                                                  : classes.sweeping) +
                                                " min-w-40 ml-4 mr-4 mb-0 mt-2 flex flex-col rounded items-center "
                                              }
                                            >
                                              <span
                                                className={
                                                  "font-bold" +
                                                  " " +
                                                  (details.service_line ===
                                                  "Snow"
                                                    ? classes.snowText
                                                    : details.service_line ===
                                                      "Land"
                                                    ? classes.landscapeText
                                                    : details.service_line ===
                                                      "Sweeping"
                                                    ? classes.sweepingText
                                                    : classes.janitorialText)
                                                }
                                              >
                                                CASE OFFER
                                              </span>
                                              <span
                                                className={
                                                  "text-2xl font-bold mb-3.5 flex flex-row items-center" +
                                                  " " +
                                                  (details.service_line ===
                                                  "Snow"
                                                    ? classes.snowText
                                                    : details.service_line ===
                                                      "Land"
                                                    ? classes.landscapeText
                                                    : details.service_line ===
                                                      "Sweeping"
                                                    ? classes.sweepingText
                                                    : classes.janitorialText)
                                                }
                                              >
                                                ${decimalNumber(detail.case_snow_offer)}
                                              </span>
                                            </div>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              ))}
                          </Grid>
                        </>
                      )}

                      <Grid item xs={12}>
                        <div className="flex flex-col items-center w-full">
                          {details.bid_status === "No Response" &&
                            !g.open &&
                            !isCounter(g) && (
                              <Button
                                variant="text"
                                onClick={() => openField(index)}
                              >
                                <span className="outlined underline">
                                  Make an Offer
                                </span>
                              </Button>
                            )}
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <div className="mb-4"></div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              ))}

            <Grid item xs={12}>
              <div className={classes.gridAdditional}>
                <Typography noWrap className={classes.cardTitle}>
                  Additional Information
                </Typography>
                <div className="m-4 text-justify">
                  <p>{details?.exhibit_c_verbiage__c || "-"}</p>
                </div>

                {getExhibitB() !== "" && (
                  <div
                    className="flex flex-row items-center ml-4"
                    onClick={() => setOpenPDF(true)}
                  >
                    <PDFIcon className="mr-3" />
                    <span className={classes.customerContract}>
                      Customer Contract
                    </span>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div className={classes.footer}>
        {(details.bid_status === "No Response" ||
          details.bid_status === "Counter") && (
          <div className={classes.buttons}>
            <Button
              onClick={handleDecline}
              style={{
                marginRight: "10px",
              }}
              className={classes.declineButton + " w-40"}
              disabled={details.bid_status === "Counter"}
            >
              Decline All
            </Button>
            {(!checkPending() || noResponseHasCounter()) && (
              <Button
                onClick={() => handlePDF(true)}
                className={classes.actionButton + " w-40"}
                disabled={details.bid_status === "Counter"}
              >
                Accept All
              </Button>
            )}

            {checkPending() &&
              !noResponseHasCounter() &&
              details?.bid_Status !== "Best and Final Offer" && (
                <Button
                  onClick={() => setOpenCounterModal(true)}
                  className={classes.actionButton + " w-40"}
                  disabled={details.bid_status === "Counter"}
                >
                  Counter Offer
                </Button>
              )}
          </div>
        )}
      </div>
    </>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      maxWidth: "100%",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
    secondaryTitleMobile: {
      display: "flex",
      justifyContent: "space-between",
      maxWidth: "100vw",
    },
    titleFontMobile: {
      fontSize: "35px",
      fontWeight: 600,
      lineHeight: "113%",
      color: "white",
      letterSpacing: "-1px",
      marginBottom: "10px",
    },
    secondaryTitleFont: {
      fontSize: "12px",
      lineHeight: "113%",
      color: "white",
    },
    accountName: {
      width: "100vw",
    },
    accountName2: {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    infoFont: {
      color: "#0F2150",
      fontWeight: "bold",
      fontSize: 20,
    },
    infoTitle: {
      color: "#0F2150",
      fontSize: "16px",
      lineHeight: "113%",
    },
    imgButton: {
      border: "none",
      cursor: "pointer",
      textAlign: "center",
      color: "white",
    },
    imgButtonClose: {
      background: "red",
      top: 0,
      right: 0,
      border: "none",
      cursor: "pointer",
      position: "absolute",
      textAlign: "center",
      borderRadius: "5px",
      height: "25px",
      minWidth: "25px",
    },
    locationName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    mapButton: {
      flexDirection: "column",
      display: "flex",
      marginTop: "5px",
    },
    footer: {
      width: "100%",
      position: "sticky",
      bottom: "0",
      padding: "10px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      backgroundColor: "white",
    },
    buttons: {
      display: "flex",
    },
    contain: {},
    grid: {
      border: "1px solid #E0E0E0",
      borderRadius: "5px",
      background: "#FFFFFF",
      margin: "5px 0px",
      minHeight: "200px",
    },
    gridAdditional: {
      border: "1px solid #E0E0E0",
      borderRadius: "5px",
      background: "#FFFFFF",
      margin: "5px 0px",
      padding: "5px",
    },
    title: {
      fontWeight: 800,
      lineHeight: "113%",
      fontSize: "30px",
      color: "#232F64",
      letterSpacing: "-1px",
      marginTop: "21px",
      marginBottom: "20px",
    },
    cardTitle: {
      fontWeight: 800,
      lineHeight: "113%",
      color: "#232F64",
      fontSize: "25px",
      letterSpacing: "-1px",
      marginTop: "10px",
      marginLeft: "10px",
    },
    cardTitleDetail: {
      fontWeight: 800,
      lineHeight: "113%",
      color: "white",
      fontSize: "20px",
      letterSpacing: "-1px",
      marginLeft: "10px",
      height: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      marginTop: 0,
    },
    snow: {
      background:
        "linear-gradient(-45grad, #a0e0f8 0%, #a0e0f8 50%, #95ddf7 50%, #95ddf7 100%)",
      color: "#0F2150",
    },
    landscape: {
      background:
        "linear-gradient(-45grad, #08543e 0%, #08543e 50%, #005c42 50%, #005c42 100%)",
      color: "white",
    },
    janitorial: {
      background:
        "linear-gradient(-45grad, #ffe299 0%, #ffe299 50%, #ffe9b3 50%, #ffe9b3 100%)",
      color: "white",
    },
    sweeping: {
      background:
        "linear-gradient(-45grad, #ffd1da 0%, #ffd1da 50%, #ffccd6 50%, #ffccd6 100%)",
      color: "white",
    },
    snowText: {
      color: "#0F2150",
    },
    landscapeText: {
      color: "white",
    },
    janitorialText: {
      color: "white",
    },
    sweepingText: {
      color: "white",
    },
    snowBorder: {
      borderTop: "10px solid #4ec7f1",
    },
    landscapeBorder: {
      borderTop: "10px solid #064633",
    },
    janitorialBorder: {
      borderTop: "10px solid #ffe193",
    },
    sweepingBorder: {
      borderTop: "10px solid #ffd1da",
    },
    cardDetailInput: {
      width: "20%",
      marginTop: "20px",
    },
    cardDetailName: {
      color: "gray",
      fontWeight: "bold",
    },
    cardDetailDescription: {
      fontWeight: "bold",
    },
    styleImg: {},
    iframeBlock: {
      height: "93%",
      marginBottom: "10px",
    },
    image: {
      width: "100%",
      height: "auto",
    },
    style: {
      position: "absolute" as "absolute",
      left: "50%",
      transform: "translate(-50%, 2.5%)",
      backgroundColor: "white",
      borderRadius: "5px",
      width: "80%",
      height: "95%",
    },
    greenStatus: {
      backgroundColor: "#d7f5e3",
      color: "#4e996c",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    counterDiv: {
      height: "100%",
      display: "grid",
      alignItems: "center",
    },
    coutnerStatus: {
      backgroundColor: "#ffd978",
      color: "#665730",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    newBidStatus: {
      backgroundColor: "#fff",
      color: "#3d7556",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      border: "solid 1px #3d7556",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    expiredStatus: {
      backgroundColor: "gray",
      color: "black",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    blueStatus: {
      backgroundColor: "#4ec7f1",
      color: "#22586a",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    redStatus: {
      backgroundColor: "#fed5d5",
      color: "#ff3b5f",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    yellowStatus: {
      backgroundColor: "#ffd978",
      color: "#665730",
      borderRadius: "20px",
      padding: "5px 10px",
      fontSize: "15px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    statusPill: {
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    cardIndicator: {
      minHeight: "80px",
      padding: "10px",
      borderTopRightRadius: "5px",
      borderTopLeftRadius: "5px",
    },
    divider: {
      marginTop: "10px",
      marginBottom: "10px",
    },
    counterInput: {
      margin: "5px",
      width: "80px",
      "& .MuiInputBase-input": {
        padding: "5px",
      },
    },
    cardInput: {
      backgroundColor: "#f1fbfe",
    },
    cardInputCoutner: {
      backgroundColor: "#fff7e4",
    },
    customerContract: {
      fontSize: "20px",
      fontWeight: "bold",
      color: "#232F64",
      cursor: "pointer",
    },
    actionButton: {
      border: "1px solid #0F2150",
      borderRadius: "100px",
      backgroundColor: "#0F2150",
      color: "#fff",
      "&.Mui-disabled": {
        border: "1px solid #e2e5ea",
        backgroundColor: "#e2e5ea",
        color: "#b2b7c6",
      },
      "&:hover": {
        backgroundColor: "#1b3a8c",
      },
    },
    declineButton: {
      border: "1px solid #0F2150",
      borderRadius: "100px",
      backgroundColor: "#fff",
      color: "#0F2150",
      "&.Mui-disabled": {
        border: "1px solid #e2e5ea",
        backgroundColor: "#e2e5ea",
        color: "#b2b7c6",
      },
    },
    iconServiceLine: {
      height: "100%",
      display: "flex",
      alignItems: " center",
      flexDirection: "row",
    },
    cardIncrementCounter: {
      color: "#0F2150",
      fontWeight: "bold",
      fontSize: "13px",
    },
    toogleIcon: {
      position: "absolute",
      display: "flex",
      right: "17px",
      marginTop: "10px",
    },
    iframeBlockImg: {
      width: "100%",
      margin: "5px",
      backgroundColor: "white",
      position: "absolute",
    },
    carouselImg: {
      maxHeight: "85vh",
    },
    counterModalMessage: {
      padding: "20px",
    },
    counterModalStyle: {
      position: "absolute" as "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      borderRadius: "5px",
      width: "80%",
    },
  })
)

export default BidDetailsMobile
